import React from "react";
import "../../../assets/styles/companion-visitor.scss";

type TextBlock = {
  /** Başlık (örn. Refakatçi, Ziyaretçi) */
  title: string;
  /** Başlığın altında serbest paragraf açıklamaları */
  paragraphs?: string[];
  /** Nokta maddeler halinde kurallar/liste */
  list?: string[];
};

export type CompanionVisitorProps = {
  companion: TextBlock;   // Sol kolon (Refakatçi)
  visitor: TextBlock;     // Sağ kolon (Ziyaretçi)
  accentColor?: string;   // #2ba87a" varsayılan
  maxWidth?: number;      // 1200 varsayılan
};

const CompanionVisitor: React.FC<CompanionVisitorProps> = ({
  companion,
  visitor,
  accentColor = "#2ba87a",
  maxWidth = 1200,
}) => {
  const cssVars: React.CSSProperties = {
    // @ts-ignore
    "--cv-accent": accentColor,
    "--cv-max": `${maxWidth}px`,
  };

  return (
    <section className="companion-visitor" style={cssVars}>
      <div className="cv-container">
        <div className="cv-grid">
          {/* SOL: REFAKATÇİ */}
          <article className="cv-card">
            <h2 className="cv-title">
              {companion.title}
              <span className="cv-underline" aria-hidden="true" />
            </h2>

            {companion.paragraphs?.map((p, i) => (
              <p className="cv-p" key={`cp-${i}`} dangerouslySetInnerHTML={{ __html: p }} />
            ))}

            {companion.list && companion.list.length > 0 && (
              <ul className="cv-list">
                {companion.list.map((li, i) => (
                  <li key={`cl-${i}`} dangerouslySetInnerHTML={{ __html: li }} />
                ))}
              </ul>
            )}
          </article>

          {/* SAĞ: ZİYARETÇİ */}
          <article className="cv-card right">
            <h2 className="cv-title right">
              {visitor.title}
              <span className="cv-underline right" aria-hidden="true" />
            </h2>

            {visitor.paragraphs?.map((p, i) => (
              <p
                className="cv-p right"
                key={`vp-${i}`}
                dangerouslySetInnerHTML={{ __html: p }}
              />
            ))}

            {visitor.list && visitor.list.length > 0 && (
              <ul className="cv-list right">
                {visitor.list.map((li, i) => (
                  <li key={`vl-${i}`} dangerouslySetInnerHTML={{ __html: li }} />
                ))}
              </ul>
            )}
          </article>
        </div>
      </div>
    </section>
  );
};

export default CompanionVisitor;
